import React from "react";

import clsx from "clsx";

import { Chip as MuiChip, Tooltip } from "@material-ui/core";

import EmployeeNumber from "./EmployeeNumber";
import Entity from "./Entity";
import Status from "./Status";

export default function Chip({
  color,
  label,
  monospace,
  tooltip,
  value,
  ...props
}) {
  if (!label && !value) {
    return null;
  }

  const className = clsx(color, {
    monospace,
  });

  const chip = (
    <MuiChip className={className} label={label || value} {...props} />
  );

  if (tooltip) {
    return <Tooltip title={tooltip}>{chip}</Tooltip>;
  }

  return chip;
}

Chip.EmployeeNumber = EmployeeNumber;
Chip.Entity = Entity;
Chip.Status = Status;
